import { environment } from '@environments/environment';

/**
 * @description Decrypt.
 * @param {string} data Data.
 * @returns {Promise<string>}
 */
export async function decrypt(data: any): Promise<string> {
  try {
    const algorithm = environment.CRYPTO_GRAPHQL.ALGORITHM;

    const key = await crypto.subtle.importKey(
      'raw',
      new TextEncoder().encode(environment.CRYPTO_GRAPHQL.KEY),
      algorithm,
      true,
      ['decrypt']
    );
    const iv = new TextEncoder().encode(environment.CRYPTO_GRAPHQL.SECRET);

    const buffer = Uint8Array.from(atob(data), (c) => c.charCodeAt(0));

    const decrypt = await crypto.subtle.decrypt(
      {
        name: algorithm,
        iv,
        tagLength: 128
      },
      key,
      buffer
    );

    return new TextDecoder().decode(decrypt);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);

    const message = 'Failed to decrypt graphql response data';
    throw new Error(message);
  }
}
